/* Pick Presso landing page helpers.
   The native main-product buy box stays the single source of truth: every other
   selector on the page mirrors it, and add-to-cart always goes through the theme's
   own product form so the cart drawer, upsells and analytics behave as usual. */
(function () {
  var config = window.PickPresso || {};
  var COLOR = config.colorOption || 'Color';
  var SET = config.setOption || 'Set';
  var DUO_SET = config.duoSet || 'Coffee Date Duo';
  var duoSecond = null; // Device 2 color for the Duo; Device 1 is the product's Color option
  // No colour counts as chosen until the shopper picks one (a shared ?variant= link counts as a pick).
  var colorChosen = /[?&]variant=/.test(window.location.search);
  var duoSecondChosen = false;
  var COLOUR_PROMPT = 'Colour';

  function mainRoot() {
    return document.querySelector('[id^="MainProduct-"]');
  }

  function mainPicker() {
    var root = mainRoot();
    return root ? root.querySelector('variant-selects') : null;
  }

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/"/g, '\\"');
  }

  function findSelect(picker, optionName) {
    return (
      picker.querySelector('select[name="options[' + cssEscape(optionName) + ']"]') ||
      picker.querySelector('select[name="' + cssEscape(optionName) + '"]')
    );
  }

  function currentValue(optionName) {
    var picker = mainPicker();
    if (!picker) return null;
    var checked = picker.querySelector('input[type="radio"][name="' + cssEscape(optionName) + '"]:checked');
    if (checked) return checked.value;
    var select = findSelect(picker, optionName);
    return select ? select.value : null;
  }

  function selectMain(optionName, value) {
    var picker = mainPicker();
    if (!picker) return false;
    var radio = picker.querySelector(
      'input[type="radio"][name="' + cssEscape(optionName) + '"][value="' + cssEscape(value) + '"]'
    );
    if (radio) {
      if (!radio.checked) radio.click();
      return true;
    }
    var select = findSelect(picker, optionName);
    if (select && select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return !!select;
  }

  function scrollToBuyBox() {
    var picker = mainPicker() || mainRoot();
    if (!picker) return;
    var top = picker.getBoundingClientRect().top + window.pageYOffset - 110;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
  }

  function updateInclusionPanels() {
    var set = currentValue(SET);
    document.querySelectorAll('[data-pp-inclusions]').forEach(function (box) {
      var panels = box.querySelectorAll('[data-pp-set-panel]');
      var match = false;
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-pp-set-panel') === set;
        panel.hidden = !on;
        if (on) match = true;
      });
      if (!match && panels[0]) panels[0].hidden = false;
    });
  }

  /* ---------- Mirrored buy boxes (final CTA) ---------- */
  function syncBuyBox(box) {
    var variants;
    try {
      variants = JSON.parse(box.querySelector('[data-pp-variants]').textContent);
    } catch (e) {
      return;
    }
    var color = currentValue(COLOR);
    var set = currentValue(SET);

    box.querySelectorAll('input[data-pp-option]').forEach(function (input) {
      var option = input.getAttribute('data-pp-option');
      var value = option === COLOR ? (colorChosen ? color : null) : option === SET ? set : null;
      if (option === COLOR && !colorChosen) input.checked = false;
      else if (value !== null) input.checked = input.value === value;
    });

    var label = box.querySelector('[data-pp-selected-color]');
    if (label) label.textContent = colorChosen && color ? color : 'Choose one';

    var variant = variants.filter(function (v) {
      return v.options.indexOf(color) !== -1 && v.options.indexOf(set) !== -1;
    })[0];
    var total = box.querySelector('[data-pp-total]');
    var button = box.querySelector('[data-pp-add]');
    if (variant) {
      if (total) total.textContent = variant.price;
      if (button) {
        button.disabled = !variant.available;
        var text = button.querySelector('[data-pp-add-label]');
        if (text) text.textContent = variant.available ? button.getAttribute('data-label') : button.getAttribute('data-soldout');
      }
      box.setAttribute('data-variant-id', variant.id);
    }
  }

  /* ---------- Coffee Date Duo: a color for each device ---------- */
  function syncDuo() {
    var boxes = document.querySelectorAll('[data-pp-duo]');
    if (!boxes.length) return;
    var isDuo = currentValue(SET) === DUO_SET;
    var first = currentValue(COLOR);
    boxes.forEach(function (box) {
      box.hidden = !isDuo;
      box.querySelectorAll('[data-pp-duo-color]').forEach(function (pill) {
        var device = pill.getAttribute('data-pp-duo-device');
        var value = pill.getAttribute('data-pp-duo-color');
        var on = device === '1' ? colorChosen && value === first : duoSecondChosen && value === duoSecond;
        pill.setAttribute('aria-checked', String(on));
      });
      box.querySelectorAll('[data-pp-duo-input]').forEach(function (input) {
        // Only named (and so submitted) while the Duo is selected; the theme's add-to-cart
        // gathers fields itself and does not respect `disabled`.
        input.disabled = !isDuo;
        if (isDuo) input.setAttribute('name', input.getAttribute('data-pp-name'));
        else input.removeAttribute('name');
        input.value = (input.getAttribute('data-pp-duo-input') === '1' ? first : duoSecond) || '';
      });
    });
  }

  function clearColourPrompt() {
    document.querySelectorAll('.pp-needs-colour').forEach(function (el) { el.classList.remove('pp-needs-colour'); });
  }

  function missingColour() {
    if (!colorChosen) return 'main';
    if (currentValue(SET) === DUO_SET && !duoSecondChosen) return 'duo';
    return null;
  }

  function promptColour(fromFinal, which) {
    var target;
    if (which === 'duo') {
      target = document.querySelector(fromFinal ? '.pp-buy [data-pp-duo]' : '.product__info-wrapper [data-pp-duo]');
    } else if (fromFinal) {
      target = document.querySelector('[data-pp-buy] fieldset');
    } else {
      target = document.querySelector('[data-pp-bubble]');
    }
    if (!target) return;
    clearColourPrompt();
    void target.offsetWidth;
    target.classList.add('pp-needs-colour');
    var label = target.querySelector('[data-pp-bubble-label]');
    if (label) label.textContent = 'Pick a colour';
    var rect = target.getBoundingClientRect();
    if (rect.top < 80 || rect.bottom > window.innerHeight - 80) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, rect.top + window.pageYOffset - window.innerHeight / 3), behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest(
      '[id^="MainProduct-"] product-form button[name="add"], .sticky-atc__add_button, [id^="SectionAtcBtn-"], .sticky-atc button[type="submit"], .sticky-atc button[name="add"], [data-pp-add]'
    );
    if (!btn) return;
    var which = missingColour();
    if (!which) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    promptColour(!!btn.closest('[data-pp-buy]'), which);
  }, true);

  function syncAll() {
    syncDuo();
    updateInclusionPanels();
    syncBubble();
    document.querySelectorAll('[data-pp-buy]').forEach(syncBuyBox);
  }

  function addFromMirror(box) {
    var root = mainRoot();
    if (!root) return;
    var button = root.querySelector('product-form button[name="add"]');
    var idInput = root.querySelector('product-form form input[name="id"]');
    var variantId = box.getAttribute('data-variant-id');
    if (idInput && variantId) idInput.value = variantId;
    if (button && !button.disabled) {
      button.click();
    } else {
      scrollToBuyBox();
    }
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (target.matches('[data-pp-buy] input[data-pp-option]') && target.getAttribute('data-pp-option') === COLOR) {
      colorChosen = true;
      clearColourPrompt();
    }
    if (target.closest('.sticky-atc') && target.tagName === 'SELECT') {
      colorChosen = true;
      clearColourPrompt();
    }
    if (target.matches('[data-pp-buy] input[data-pp-option]')) {
      selectMain(target.getAttribute('data-pp-option'), target.value);
      // The theme updates its own state on the click; re-sync once it has run.
      setTimeout(syncAll, 0);
      return;
    }
    if (target.closest('variant-selects') || target.closest('.sticky-atc')) {
      setTimeout(syncAll, 0);
    }
  });

  document.addEventListener('click', function (event) {
    var duoPill = event.target.closest('[data-pp-duo-color]');
    if (duoPill) {
      event.preventDefault();
      var value = duoPill.getAttribute('data-pp-duo-color');
      if (duoPill.getAttribute('data-pp-duo-device') === '1') {
        colorChosen = true;
        selectMain(COLOR, value);
      } else {
        duoSecond = value;
        duoSecondChosen = true;
      }
      clearColourPrompt();
      setTimeout(syncAll, 0);
      return;
    }
    var dot = event.target.closest('[data-pp-color]');
    if (dot) {
      event.preventDefault();
      event.stopPropagation();
      colorChosen = true;
      clearColourPrompt();
      selectMain(COLOR, dot.getAttribute('data-pp-color'));
      setTimeout(syncAll, 0);
      return;
    }
    var chooser = event.target.closest('[data-pp-choose-set]');
    if (chooser) {
      event.preventDefault();
      selectMain(SET, chooser.getAttribute('data-pp-choose-set'));
      setTimeout(syncAll, 0);
      scrollToBuyBox();
      return;
    }
    var scroller = event.target.closest('[data-pp-scroll-buy]');
    if (scroller) {
      // Without a buy box on the page (e.g. the homepage) the link just navigates.
      if (!mainPicker() && !mainRoot()) return;
      event.preventDefault();
      scrollToBuyBox();
      return;
    }
    var share = event.target.closest('[data-pp-share]');
    if (share) {
      event.preventDefault();
      var url = new URL(share.getAttribute('data-pp-share'), window.location.origin).href;
      var text = share.getAttribute('data-pp-share-text') || '';
      if (navigator.share) {
        navigator.share({ title: document.title, text: text, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var label = share.textContent;
          share.textContent = share.getAttribute('data-pp-copied');
          setTimeout(function () { share.textContent = label; }, 2000);
        });
      }
      return;
    }
    var add = event.target.closest('[data-pp-add]');
    if (add) {
      event.preventDefault();
      addFromMirror(add.closest('[data-pp-buy]'));
    }
  });

  /* Muted demo loops only download and play while on screen. */
  function initAutoplay() {
    var videos = document.querySelectorAll('[data-pp-autoplay] video:not([data-pp-ready])');
    if (!videos.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      videos.forEach(function (video) {
        video.setAttribute('data-pp-ready', '');
        video.controls = true;
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.muted = true;
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    videos.forEach(function (video) {
      video.setAttribute('data-pp-ready', '');
      video.muted = true;
      observer.observe(video);
    });
  }

  /* ---------- Motion: in-view flags, scroll reveal, pour line ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  // Animations only run while their section is on screen.
  function initInView() {
    var sections = document.querySelectorAll('.pp-section:not([data-pp-watched])');
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.setAttribute('data-pp-inview', ''); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.toggleAttribute('data-pp-inview', entry.isIntersecting);
        });
      },
      { rootMargin: '120px 0px' }
    );
    sections.forEach(function (el) {
      el.setAttribute('data-pp-watched', '');
      observer.observe(el);
    });
  }

  var REVEAL_GROUPS = [
    '.pp-head',
    '.pp-steps > .pp-step',
    '.pp-cards > .pp-card',
    '.pp-methods > .pp-method',
    '.pp-offers > .pp-offer',
    '.pp-included > .pp-included__item',
    '.pp-videos > .pp-video',
    '.pp-points > .pp-point',
    '.pp-faq__list > .pp-faq__item',
    '.pp-split__media',
    '.pp-buy',
    '.pp-final .pp-media'
  ];

  function initReveal() {
    var lite = document.documentElement.classList.contains('pp-lite');
    if (lite || reduceMotion || designMode || !('IntersectionObserver' in window)) return;
    var targets = [];
    REVEAL_GROUPS.forEach(function (selector) {
      document.querySelectorAll('.pp-section ' + selector + ':not(.pp-reveal)').forEach(function (el) {
        var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--pp-i', Math.min(siblings, 6));
        targets.push(el);
      });
    });
    // On desktop the gallery and reviews are grids; on mobile they are swipe rows (left alone).
    if (window.matchMedia('(min-width: 750px)').matches) {
      document.querySelectorAll('.pp-gallery > .pp-gallery__item:not(.pp-reveal), .pp-reviews > .pp-review-card:not(.pp-reveal)').forEach(function (el, i) {
        el.style.setProperty('--pp-i', Math.min(i, 6));
        targets.push(el);
      });
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    targets.forEach(function (el) {
      el.classList.add('pp-reveal');
      observer.observe(el);
    });
  }

  // The pour line fills as the visitor scrolls through the steps section.
  var pours = [];
  var pourTicking = false;
  function updatePours() {
    pourTicking = false;
    var vh = window.innerHeight;
    pours.forEach(function (pour) {
      var section = pour.closest('.pp-section');
      var rect = section.getBoundingClientRect();
      var progress = (vh * 0.85 - rect.top) / (rect.height * 0.75);
      progress = Math.max(0, Math.min(1, progress));
      pour.style.setProperty('--pp-progress', progress.toFixed(3));
      pour.querySelectorAll('.pp-pour__dot').forEach(function (dot) {
        var at = parseFloat(dot.style.getPropertyValue('--pp-dot-at')) / 100;
        dot.classList.toggle('is-filled', progress >= at);
      });
    });
  }
  function requestPourUpdate() {
    if (!pourTicking) {
      pourTicking = true;
      window.requestAnimationFrame(updatePours);
    }
  }
  function initPour() {
    pours = Array.prototype.slice.call(document.querySelectorAll('[data-pp-pour]'));
    if (!pours.length) return;
    if (reduceMotion || document.documentElement.classList.contains('pp-lite')) {
      pours.forEach(function (pour) {
        pour.style.setProperty('--pp-progress', '1');
        pour.querySelectorAll('.pp-pour__dot').forEach(function (dot) { dot.classList.add('is-filled'); });
      });
      return;
    }
    updatePours();
  }
  window.addEventListener('scroll', requestPourUpdate, { passive: true });
  window.addEventListener('resize', requestPourUpdate);

  /* ---------- Gallery extras: color bubble on the image, review under it ---------- */
  function initGalleryExtras() {
    var source = document.querySelector('[data-pp-gallery-extras]');
    var root = mainRoot();
    if (!source || !root) return;
    var viewer = root.querySelector('.product__media-wrapper slider-component[id^="GalleryViewer-"]');
    var gallery = root.querySelector('.product__media-wrapper media-gallery');
    var bubble = source.querySelector('[data-pp-bubble]');
    var review = source.querySelector('[data-pp-review]');
    if (bubble && viewer) {
      if (getComputedStyle(viewer).position === 'static') viewer.style.position = 'relative';
      viewer.appendChild(bubble);
    }
    if (review && gallery) gallery.insertAdjacentElement('afterend', review);
    source.remove();
  }

  function syncBubble() {
    var color = currentValue(COLOR);
    document.querySelectorAll('[data-pp-bubble]').forEach(function (bubble) {
      bubble.querySelectorAll('[data-pp-color]').forEach(function (dot) {
        dot.setAttribute('aria-checked', colorChosen && dot.getAttribute('data-pp-color') === color ? 'true' : 'false');
      });
      var label = bubble.querySelector('[data-pp-bubble-label]');
      if (label && !bubble.classList.contains('pp-needs-colour')) label.textContent = colorChosen && color ? color : COLOUR_PROMPT;
    });
  }

  /* ---------- Demo offer timer (preview mock-up) + share button ---------- */
  function initDemoTimers() {
    document.querySelectorAll('[data-pp-demo-timer]:not([data-pp-ready])').forEach(function (box) {
      box.setAttribute('data-pp-ready', '');
      var cycle = (parseFloat(box.getAttribute('data-cycle-hours')) || 48) * 3600 * 1000;
      var epoch = Date.UTC(2026, 0, 1);
      var parts = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { parts[k] = box.querySelector('[data-pp-t="' + k + '"]'); });
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      function tick() {
        var now = Date.now();
        var end = epoch + Math.ceil((now - epoch) / cycle) * cycle;
        var left = Math.max(0, Math.floor((end - now) / 1000));
        parts.d.textContent = Math.floor(left / 86400);
        parts.h.textContent = pad(Math.floor((left % 86400) / 3600));
        parts.m.textContent = pad(Math.floor((left % 3600) / 60));
        parts.s.textContent = pad(left % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Ad angle: match the hero to the ad the visitor came from (?angle=1|2|3) ---------- */
  function initAngle() {
    var angle = null;
    try {
      angle = new URLSearchParams(window.location.search).get('angle');
      if (angle) sessionStorage.setItem('ppAngle', angle);
      else angle = sessionStorage.getItem('ppAngle');
    } catch (e) {}
    if (!angle || !document.querySelector('[data-pp-angle="' + cssEscape(angle) + '"]')) return;
    document.querySelectorAll('[data-pp-angle]').forEach(function (el) {
      el.hidden = el.getAttribute('data-pp-angle') !== angle;
    });
  }

  /* ---------- Soft price swap when the variant changes ---------- */
  function initPriceSwap() {
    var root = mainRoot();
    var price = root && root.querySelector('.product__info-wrapper .price');
    if (!price || price.hasAttribute('data-pp-watch') || !('MutationObserver' in window)) return;
    price.setAttribute('data-pp-watch', '');
    var last = price.innerText.trim();
    new MutationObserver(function () {
      var target = root.querySelector('.product__info-wrapper .price');
      var now = target ? target.innerText.trim() : '';
      if (!target || now === last) return;
      last = now;
      target.classList.remove('pp-price-swap');
      void target.offsetWidth;
      target.classList.add('pp-price-swap');
    }).observe(price.parentElement || price, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    initAngle();
    initPriceSwap();
    initGalleryExtras();
    initDemoTimers();
    syncAll();
    initAutoplay();
    initInView();
    initReveal();
    initPour();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
